(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jesimaik-autumn-sale-2026"] && !Shopify.designMode) return;
  try {
    
(function() {
  const roots = document.querySelectorAll('.jm-autumn');
  if (!roots.length) return;

  const requiredProducts = {
    touring: [
      { handle: 'h7s', scene: '秋のツーリングに' },
      { handle: 'h6', scene: 'ツーリングの定番' },
      { handle: 'h5', scene: 'はじめてのインカムに' },
      { handle: 'r16-pro', scene: '快適なグループ通話に' },
      { handle: 'r18lite', scene: '気軽なツーリングに' },
      { handle: 'x6s', scene: 'グループツーリングに' }
    ],
    diy: [
      { handle: 'hsc30', scene: '秋のDIY・作業に' },
      { handle: 'hsc40', scene: 'ガレージ作業に' },
      { handle: 'bt1400', scene: '秋の屋外清掃に' },
      { handle: 'pdl130', scene: '洗車・アウトドア清掃に' },
      { handle: 'pocket2', scene: '手軽な洗車・清掃に' },
      { handle: 'tf64a5', scene: '洗車後の水滴飛ばしに' },
      { handle: 'tf40r1', scene: '細かな清掃・乾燥に' },
      { handle: 'welder-m135d', scene: '金属補修・DIYに' },
      { handle: 'welder-m120', scene: 'はじめての溶接作業に' },
      { handle: 'k-912', scene: 'ガレージ・車内清掃に' }
    ]
  };

  const yen = (cents) => '¥' + Math.round(cents / 100).toLocaleString('ja-JP');

  function existingHandles(grid) {
    const handles = new Set();
    grid.querySelectorAll('a[href*="/products/"]').forEach(a => {
      try {
        const url = new URL(a.href, location.origin);
        const m = url.pathname.match(/\/products\/([^/?#]+)/);
        if (m) handles.add(m[1]);
      } catch(e) {}
    });
    return handles;
  }

  function cardHTML(product, scene) {
    const variant = product.variants && product.variants.length ? product.variants[0] : null;
    const price = variant ? variant.price : product.price;
    const compare = variant ? variant.compare_at_price : product.compare_at_price;
    const discount = compare && compare > price
      ? Math.round((compare - price) * 100 / compare)
      : 0;

    const image = product.featured_image || (product.images && product.images[0]) || '';
    const productUrl = '/products/' + product.handle;

    return `
      <article class="jm-autumn__card jm-autumn__card--autofill" data-product-handle="${product.handle}">
        <a class="jm-autumn__card-media" href="${productUrl}">
          <span class="jm-autumn__badge">SALE</span>
          ${image ? `<img src="${image}" alt="${product.title.replace(/"/g,'&quot;')}" loading="lazy">` : ''}
        </a>

        <div class="jm-autumn__card-body">
          <div class="jm-autumn__card-scene">${scene}</div>

          <h3 class="jm-autumn__card-title">
            <a href="${productUrl}">${product.title}</a>
          </h3>

          <div class="jm-autumn__card-desc">&nbsp;</div>

          <div class="jm-autumn__price">
            <div class="jm-autumn__price-row jm-autumn__price-row--regular">
              ${compare && compare > price ? `<span class="jm-autumn__regular-price">通常価格 ${yen(compare)}</span>` : ''}
              ${discount > 0 ? `<span class="jm-autumn__discount-badge">${discount}%OFF</span>` : ''}
            </div>

            <div class="jm-autumn__price-row jm-autumn__price-row--sale">
              <span class="jm-autumn__sale-label">SALE</span>
              <span class="jm-autumn__sale-price">${yen(price)}</span>
              <span class="jm-autumn__tax">税込</span>
            </div>
          </div>

          <a class="jm-autumn__card-btn" href="${productUrl}">商品を見る</a>
        </div>
      </article>
    `;
  }

  async function ensureProducts(root, groupName) {
    const grid = root.querySelector(`[data-jm-group="${groupName}"]`);
    if (!grid) return;

    const existing = existingHandles(grid);
    const needed = requiredProducts[groupName].filter(item => !existing.has(item.handle));

    for (const item of needed) {
      try {
        const res = await fetch(`/products/${item.handle}.js`, { credentials: 'same-origin' });
        if (!res.ok) continue;
        const product = await res.json();
        grid.insertAdjacentHTML('beforeend', cardHTML(product, item.scene));
      } catch (e) {
        console.warn('JESIMAIK Autumn Sale: product load failed', item.handle, e);
      }
    }
  }

  function removeUnwantedDIY(root) {
    const grid = root.querySelector('[data-jm-group="diy"]');
    if (!grid) return;

    grid.querySelectorAll('a[href*="/products/3wbd-18"]').forEach(a => {
      const card = a.closest('.jm-autumn__card');
      if (card) card.remove();
    });
  }



  function initCouponModal(root) {
    const modal = root.querySelector('.jm-coupon-modal');
    const openBtn = root.querySelector('.jm-autumn__coupon-open');
    const form = root.querySelector('.jm-coupon-form');
    if (!modal || !openBtn || !form) return;

    const closeButtons = modal.querySelectorAll('[data-coupon-close]');
    const firstInput = modal.querySelector('input[type="email"]');
    const entry = modal.querySelector('[data-coupon-entry]');
    const success = modal.querySelector('[data-coupon-success]');
    const errorBox = modal.querySelector('[data-coupon-error]');
    const submitBtn = modal.querySelector('[data-coupon-submit]');
    const copyBtn = modal.querySelector('.jm-coupon-copy');
    const frame = root.querySelector('.jm-coupon-submit-frame');

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';

      setTimeout(() => {
        if (firstInput && success && success.hidden) firstInput.focus();
      }, 50);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    function showCouponSuccess() {
      if (entry) entry.hidden = true;
      if (success) success.hidden = false;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function submitCouponEmail() {
      if (!firstInput || !firstInput.value.trim() || !firstInput.checkValidity()) {
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = 'メールアドレスをご確認のうえ、もう一度お試しください。';
        }
        if (firstInput) firstInput.focus();
        return;
      }

      if (!frame) {
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = '登録処理を開始できませんでした。もう一度お試しください。';
        }
        return;
      }

      if (errorBox) errorBox.hidden = true;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = '登録中...';
      }

      // Submit to Shopify in a hidden iframe so the campaign page never navigates away.
      form.setAttribute('target', frame.getAttribute('name'));

      try {
        HTMLFormElement.prototype.submit.call(form);

        // Show the coupon immediately after a valid Shopify form submission starts.
        // This keeps the customer on the current page.
        setTimeout(() => {
          showCouponSuccess();

          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'クーポンを受け取る';
          }
        }, 700);

      } catch (err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'クーポンを受け取る';
        }

        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = '登録に失敗しました。もう一度お試しください。';
        }
      }
    }

    // Never allow the page itself to submit/navigate.
    if (!form.dataset.nativeBlocked) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        submitCouponEmail();
      }, true);
      form.dataset.nativeBlocked = '1';
    }

    if (firstInput && !firstInput.dataset.enterBound) {
      firstInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
          submitCouponEmail();
        }
      });
      firstInput.dataset.enterBound = '1';
    }

    if (submitBtn && !submitBtn.dataset.bound) {
      submitBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        submitCouponEmail();
      });
      submitBtn.dataset.bound = '1';
    }

    if (!openBtn.dataset.bound) {
      openBtn.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
      openBtn.dataset.bound = '1';
    }

    closeButtons.forEach(btn => {
      if (!btn.dataset.bound) {
        btn.addEventListener('click', closeModal);
        btn.dataset.bound = '1';
      }
    });

    if (copyBtn && !copyBtn.dataset.bound) {
      copyBtn.addEventListener('click', async function(e) {
        e.preventDefault();

        const code = this.getAttribute('data-code') || '';

        try {
          await navigator.clipboard.writeText(code);
          this.textContent = 'コピー済み';
        } catch (err) {
          const temp = document.createElement('textarea');
          temp.value = code;
          temp.style.position = 'fixed';
          temp.style.opacity = '0';
          document.body.appendChild(temp);
          temp.select();

          try {
            document.execCommand('copy');
            this.textContent = 'コピー済み';
          } catch (copyErr) {
            this.textContent = code;
          }

          temp.remove();
        }

        setTimeout(closeModal, 650);
      });

      copyBtn.dataset.bound = '1';
    }
  }

  async function initProducts(root) {
    removeUnwantedDIY(root);
    await ensureProducts(root, 'touring');
    await ensureProducts(root, 'diy');
    removeUnwantedDIY(root);
  }

  async function initAll() {
    for (const root of roots) {
      initCouponModal(root);
      await initProducts(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event) {
    const root = event.target && event.target.querySelector
      ? event.target.querySelector('.jm-autumn')
      : null;
    if (root) {
      initCouponModal(root);
      initProducts(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
